export default {"src":"/_next/static/media/clipboardWithWave_40.1af3b7a8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};